import '../../App.css';
import NotFound from '../../components/commons/NotFound';

function NotFoundPage() {
	return (
        <NotFound />
	);
}

export default NotFoundPage;